module.exports = __webpack_public_path__ + "static/media/conocephalus_fuscus_BD_004_APA.fdb9018e.png";